import Swiper from 'swiper';

const CARDS_CAROUSEL_SELECTOR = '.js-cards-carousel';
const PREV_SLIDE_BTN_CLASS = 'js-slide-prev';
const NEXT_SLIDE_BTN_CLASS = 'js-slide-next';
let tabsNavItems = document.querySelectorAll('.custom-tabs .nav-item');



// Run code
var cardCarousels = document.querySelectorAll(CARDS_CAROUSEL_SELECTOR);

cardCarousels.forEach(carousel => {
    setUp(carousel);
});

document.addEventListener('click', function (event) {
    handleControlsBtnClick(event, true);
    handleControlsBtnClick(event, false);

    /* --if complectation on other tab--
    let tabId = event.target.parentNode.id;
    if(tabId == "nav-elements-tab" || tabId == "nav-details-tab"){
    	updateСarousel(cardCarousels);
	}*/

});

/* --if complectation on other tab--
window.addEventListener("load", function (event) {
	if (tabsNavItems) {
        if (location.hash) {
            if(location.hash == '#nav-elements'){
            	updateСarousel(cardCarousels);
            }
        }
    }
});
*/

function updateСarousel(cardCarousels) {
	setTimeout(function(){
		cardCarousels.forEach(carousel => {
		    carousel.swiper.update();
		});
	}, 200); // 0.2с для появления отрисовки
}

// Environmental code
function setUp(carousel) {
    buildSwiperInstanceForCarousel(carousel);
}

function buildSwiperInstanceForCarousel(carousel) {
	var pv1600 = carousel.classList.contains('js-cards-carousel-sm') ? 4 : 6;
	
    new Swiper(carousel, {
        slidesPerView: 2.18,
        spaceBetween: 10,
        breakpoints: {
            768: {
                slidesPerView: 3
            },
            1024: {
                slidesPerView: 4,
                spaceBetween: 15,
            },
            1600: {
               slidesPerView: pv1600
            },
        },
        on: {
            init: function () {
                adjustControlsButtonsActivity(this);
            },

            slideChange: function() {
                adjustControlsButtonsActivity(this);
            },
        }
    });
}

function handleControlsBtnClick({ target }, isNext = true) {
    var btnClass = isNext ? NEXT_SLIDE_BTN_CLASS : PREV_SLIDE_BTN_CLASS;

    var controlBtn = target.classList.contains(btnClass) ? target : target.closest(`.${btnClass}`);

    if (controlBtn) {
        let correlatingCarousel = controlBtn.closest(CARDS_CAROUSEL_SELECTOR);
        if (!correlatingCarousel) throw new Error(`No carrousel specified for ${controlBtn} control`);

        if (correlatingCarousel.swiper) {
            if (isNext) correlatingCarousel.swiper.slideNext();
            else correlatingCarousel.swiper.slidePrev();
        }
    }
}


function adjustControlsButtonsActivity(swiper) {
    var prevBtn = swiper.el.querySelector(`.${PREV_SLIDE_BTN_CLASS}`);
    var nextBtn = swiper.el.querySelector(`.${NEXT_SLIDE_BTN_CLASS}`);


    if (swiper.isBeginning) {
        prevBtn.setAttribute('disabled', '');
    } else {
        prevBtn.removeAttribute('disabled');
    }

    if (swiper.isEnd) {
        nextBtn.setAttribute('disabled', '');
    } else {
        nextBtn.removeAttribute('disabled');
    }
}
